import { FilterModel } from '../convert-filter'

/**
 * Converts a column filter to a time filter
 */
export function convertToTimeFilters<T>(
  filterModel: FilterModel<T>,
  columns: Array<keyof T>,
) {
  for (const column of columns) {
    const columnFilter = filterModel[column]
    if (!columnFilter || columnFilter.filterType == 'time') {
      continue
    }

    columnFilter.filterType = 'time'
  }
}
